module.exports = __webpack_public_path__ + "img/6.98f0ae1e.jpg";